// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3-lXB","col":"Table_col__2pnr-","fulfillmentStatus":"Table_fulfillmentStatus__1bngV","emailCol":"Table_emailCol__1HW6m"};